import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IDesig_Level {
desig_level_id:number,
desig_level_name:string,
is_active:boolean
}

interface IDesig_LevelData {
    list?: Array<IDesig_Level>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IDesig_LevelData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const desig_levelSlice = createSlice({
    name: "desig_level",
    initialState,
    reducers: {
        setDesig_LevelList: (state, _action: PayloadAction<IDesig_LevelData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetDesig_LevelToInit: (state) => {
            state = initialState;
        },
        setDesig_LevelMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setDesig_LevelList, resetDesig_LevelToInit, setDesig_LevelMessage } = desig_levelSlice.actions;

export default desig_levelSlice.reducer;

